export default __webpack_public_path__ + "static/media/kettle-gray.b96e47c8.svg";